import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "modal", "form"]
  static values = { placeGroupId: Number }

  connect() {
    console.log("BulkPlacesModalController connected")
    // Handle escape key to close modal
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  open() {
    console.log("Opening bulk places modal")
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundHandleKeydown)

    // Focus on the textarea
    const textarea = this.formTarget.querySelector("textarea")
    if (textarea) {
      setTimeout(() => textarea.focus(), 100)
    }
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundHandleKeydown)

    // Clear form
    this.formTarget.reset()

    // Clear status area
    const statusArea = document.getElementById("bulk_places_status")
    if (statusArea) {
      statusArea.innerHTML = ""
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  handleSubmission(event) {
    // Keep modal open to show progress
    // The turbo stream response will update the status area
  }

  // Handle escape key
  disconnect() {
    document.body.style.overflow = ""
    if (this.boundCloseOnOutsideClick) {
      this.overlayTarget.removeEventListener("click", this.boundCloseOnOutsideClick)
    }
  }
}
